/* eslint-disable max-len */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'app/AppStore';
import { useIsDHCatalogSourceInUrl } from 'domains/catalog/Catalog.utils';
import { getLatestInStockReference } from 'domains/references/References.store';
import { Product } from 'pages/CatalogPage/DH/Product/Product';
import { SeePlateLink } from 'pages/CatalogPage/DH/SubcategorySection/SparePartsSection/ReferenceCardsContainer/ReferenceCard/SeePlateLink';
import { useBreakpointSelectorFull } from 'utils';
import { useResetScroll } from 'utils/hooks/useResetScroll';

export const ProductSection = () => {
  const { referenceNumber } = useParams<{ referenceNumber: string }>();
  const isDHCatalogSourceInUrl = useIsDHCatalogSourceInUrl();
  const seePlateState = useState<string | undefined>(undefined);

  useResetScroll([referenceNumber]);
  const breakpointSelectorFull = useBreakpointSelectorFull();
  const toLeft = breakpointSelectorFull({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: true,
    xml: true,
    xxl: true,
  });

  const latestInStockReference = useSelector((state: RootState) => getLatestInStockReference(state, referenceNumber));
  const seePlateComp = (
    <>
      {isDHCatalogSourceInUrl && (
        <SeePlateLink referenceNumber={latestInStockReference} seePlateState={seePlateState} fromDetail={toLeft} />
      )}
    </>
  );

  return <Product key={referenceNumber} referenceNumber={latestInStockReference} seePlate={seePlateComp} />;
};
